import { useMemo } from "react";
import { useCoursesLoaderData } from "./coursesLoader";

// This hook determines the opt-out deadline for the current term based on the type of program (IA, FA, EA).
// If you need the opt-out deadline for a specific material, you can use the `useMaterialOptDeadline` hook instead.
export default function useTermOptDeadline() {
  const { currentTerm, courses } = useCoursesLoaderData();
  const isIA = currentTerm?.institutionProgram === "inclusive_access";

  // IA logic for getting the upcoming course with the earliest opt-out deadline
  const sortedCoursesByOptOutDeadline = courses
    ?.filter(
      (course) =>
        course.optOutDeadline && new Date() < new Date(course.optOutDeadline)
    )
    .sort(
      (a, b) =>
        new Date(a.optOutDeadline).getTime() -
        new Date(b.optOutDeadline).getTime()
    );
  const upcomingCourse = sortedCoursesByOptOutDeadline?.[0];

  // FA and EA logic for the current term
  const deadlineDate = currentTerm?.optOutDeadlineDate
    ? new Date(currentTerm.optOutDeadlineDate)
    : undefined;
  const currentTermOptWindowOpen =
    currentTerm?.active && deadlineDate ? new Date() < deadlineDate : false;

  return useMemo(() => {
    return {
      optWindowOpen: isIA ? !!upcomingCourse : currentTermOptWindowOpen,
      optDeadline: isIA
        ? upcomingCourse?.optOutDeadline
        : currentTerm?.optOutDeadlineDate,
    };
  }, [
    currentTermOptWindowOpen,
    currentTerm?.optOutDeadlineDate,
    isIA,
    upcomingCourse,
  ]);
}
